import React, { useRef, useState } from "react";
import { Volume2, Loader2, Pause } from "lucide-react";
import { ttsSpeak } from "../lib/api";

const cache = new Map(); // text+voice -> base64

export const SpeakerButton = ({ text, voice = "fable", size = "md", className = "", testid }) => {
  const [loading, setLoading] = useState(false);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);

  const dims = size === "sm" ? "h-9 w-9" : size === "lg" ? "h-14 w-14" : "h-11 w-11";
  const icon = size === "sm" ? 16 : size === "lg" ? 24 : 18;

  const play = async (e) => {
    e?.stopPropagation();
    if (!text) return;
    if (playing && audioRef.current) {
      audioRef.current.pause();
      setPlaying(false);
      return;
    }
    const key = `${voice}::${text}`;
    let b64 = cache.get(key);
    try {
      if (!b64) {
        setLoading(true);
        const r = await ttsSpeak(text, voice);
        b64 = r.audio_base64;
        cache.set(key, b64);
      }
      const a = new Audio(`data:audio/mp3;base64,${b64}`);
      audioRef.current = a;
      a.onended = () => setPlaying(false);
      a.onerror = () => setPlaying(false);
      setPlaying(true);
      a.play();
    } catch (err) {
      console.error("TTS failed", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={play}
      data-testid={testid || "speaker-button"}
      aria-label="Read aloud"
      className={`group inline-flex items-center justify-center rounded-full ${dims} bg-white/5 hover:bg-yellow-300/15 border border-yellow-300/25 hover:border-yellow-300/60 transition-all hover:scale-110 ${playing ? "eigoo-pulse-gold border-yellow-300/70" : ""} ${className}`}
    >
      {loading ? (
        <Loader2 size={icon} className="animate-spin text-yellow-300" />
      ) : playing ? (
        <Pause size={icon} className="text-yellow-300" />
      ) : (
        <Volume2 size={icon} className="text-yellow-300 group-hover:scale-110 transition-transform" />
      )}
    </button>
  );
};

export default SpeakerButton;
